import { motion } from "framer-motion";

const stats = [
  {
    value: "20+ Years",
    label: "Industry Excellence",
  },
  {
    value: "200+",
    label: "Professionals & Skilled Team",
  },
  {
    value: "300+",
    label: "Projects Delivered",
  },
  {
    value: "5",
    label: "Major Airport Hubs: Delhi, Mumbai, Navi Mumbai, Lucknow, Jaipur",
  },
];

export const StatsBar = () => {
  return (
    <section className="bg-white py-16 px-6 md:px-12 lg:px-24 border-b border-gray-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-12 md:gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="flex-1 text-left md:text-center w-full md:w-auto">
              <h3 className="text-4xl md:text-5xl font-bold text-primary mb-2 tracking-tight">
                {stat.value}
              </h3>
              <p className="text-gray-900 font-medium text-lg leading-snug">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
